import clsx from 'clsx';
import React from 'react';

function TextInput(props) {
  const { isError, errorMessage, label, prefix, isRequired, ...restProps } = props;
  return (
    <div className="form-group">
      <label>
        {label} {isRequired && <span className="text-danger fw-600">*</span>}
      </label>
      <div style={{ position: 'relative' }}>
        {props.prefix && (
          <span
            style={{
              position: 'absolute',
              top: '50%',
              transform: 'translateY(-50%)',
              left: 16
            }}>
            {props.prefix}
          </span>
        )}
        <input
          {...restProps}
          style={{ ...(prefix && { paddingLeft: 52 }) }}
          className={clsx('form-control', { 'border-danger': isError })}
        />
      </div>
      {isError && errorMessage && (
        <span className="text-danger text-14 fw-normal">{errorMessage}</span>
      )}
    </div>
  );
}

export default TextInput;
